import styled from 'styled-components';

export const Container = styled.div`
  z-index: 1030;
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;

  .bg-container {
    background: ${(props) => props.theme.$ebony_clay};
    bottom: 0;
    width: 100%;
    z-index: 1032;
  }

  .bg-open {
    background: ${(props) => props.theme.$black}60;
    height: 100vh;
    width: 100%;
    position: absolute;
    top: 0;
    z-index: 1031;
  }
`;
